import { Component, input } from '@angular/core';

@Component({
  selector: 'app-cii-badge',
  standalone: true,
  templateUrl: './cii-badge.component.html',
})
export class CiiBadgeComponent {
  variant = input<'hero' | 'inline' | 'compact' | 'table'>('inline');
}
